import { useState, useCallback } from 'react';
import { useRouter } from 'next/router';

export const useShowFilters = (initialShowFilters: boolean) => {
  const [showFilters, setShowFilters] = useState(initialShowFilters);
  const router = useRouter();

  const toggleShowFilters = useCallback(() => {
    const newShowFilters = !showFilters;
    setShowFilters(newShowFilters);

    // Update URL with shallow routing to avoid triggering navigation events
    const currentQuery = { ...router.query };
    if (newShowFilters) {
      currentQuery.showFilters = 'true';
    } else {
      delete currentQuery.showFilters;
    }

    router.push(
      {
        pathname: router.pathname,
        query: currentQuery
      },
      undefined,
      { shallow: true }
    );
  }, [showFilters, router]);

  return {
    showFilters,
    toggleShowFilters
  };
};
